import { Info } from 'lucide-react';
import { LiksTooltip } from '../../components/liks/LiksTooltip/LiksTooltip';
import { useI18n } from '../../i18n/useI18n';

type LacStatsTopSectionTitleProps = {
  children: string;
};

export function LacStatsTopSectionTitle({
  children,
}: LacStatsTopSectionTitleProps) {
  const { translate } = useI18n();

  return (
    <div className="lac-tenant-stats-section__title-row">
      <h2 className="lac-tenant-overview__title">{children}</h2>
      <LiksTooltip
        className="lac-tenant-stats-section__info"
        content={translate('lac.organisations.stats.topLimitHint')}
        placement="top-start"
        describeChildren
      >
        <Info
          className="lac-tenant-stats-section__info-icon"
          strokeWidth={2}
          aria-hidden
        />
      </LiksTooltip>
    </div>
  );
}
